export const COMMUNITY_HOME_ROUTE = '/welcome?mode=community';

export function isCommunityWelcomeRequest(pathname: string, search: string): boolean {
  return pathname === '/welcome' && new URLSearchParams(search).get('mode') === 'community';
}

export function hasTenantWorkspaceContext(
  activeTenantId: number | null | undefined,
  communityWelcomeRequested: boolean,
): boolean {
  return Boolean(activeTenantId) && !communityWelcomeRequested;
}
